
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/security-status",
      function () {
        return require("private-next-pages/resources/security-status.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/security-status"])
      });
    }
  